import { ThemeSelectors } from "@at/design-system-foundation";
import styled from "styled-components";

export const GalleryBackButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => ThemeSelectors.getActionColor(theme)};
  background-color: transparent;
  border: none;
  cursor: pointer;
  min-width: 150px;
  span {
    white-space: nowrap;
    margin-left: ${({ theme }) => ThemeSelectors.getGroupOneSpacing(theme)};
  }

  svg {
    fill: ${({ theme }) => ThemeSelectors.getActionColor(theme)};
  }
`;
